<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="日期" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-date placeholder="请选择日期" v-decorator="['date', validatorRules.date]" :trigger-change="true" style="width: 100%"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保险公司" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-search-select-tag
                placeholder="请选择保险公司"
                v-decorator="['companyNumber', validatorRules.insurer]"
                :triggerChange="true"
                dict="biz_insurance_company,name,code">
              </j-search-select-tag>
              <!--<a-input v-decorator="['insurer', validatorRules.insurer]" placeholder="请输入保司编号"></a-input>-->
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="保单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator.trim="['policy', validatorRules.policy]" placeholder="请输入保单号"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="期数" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input placeholder="请录入期数" v-decorator.trim="['phase', validatorRules.phase]" />
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金比例(%)" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['brokerageRatio', validatorRules.brokerageRatio]" placeholder="请输入佣金比例" style="width:100%;"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="佣金" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number v-decorator="['brokerage', validatorRules.brokerage]" :formatter="moneyFormatter" placeholder="请输入总佣金" style="width:100%;"></a-input-number>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="项目" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                type="list"
                v-decorator="['project', validatorRules.project]" :trigger-change="true"
                dictCode="bms_project"
                placeholder="请选择项目"/>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="部门"  :labelCol="labelCol" :wrapperCol="wrapperCol">
              <j-dict-select-tag
                placeholder="请选择部门"
                v-decorator="['sysOrgCode']" :trigger-change="true"
                dictCode="sys_depart,depart_name,org_code">
              </j-dict-select-tag>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue,moneyFormatter } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'
  import JDictSelectTag from "@/components/dict/JDictSelectTag"
  import JSearchSelectTag from  "@/components/dict/JSearchSelectTag"
  export default {
    name: 'BizInsuranceDataForm',
    components: {
      JFormContainer,
      JDate,
      JDictSelectTag,
      JSearchSelectTag
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        companyName:'',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
          date: {
            rules: [
              { required: true, message: '请输入日期!'},
            ]
          },
          insurer: {
            rules: [
              { required: true, message: '请选择保险公司!'},
            ]
          },
          policy: {
            rules: [
              { required: true, message: '请输入保单号!'},
              { max: 30, message: '保单号长度不能超过30'},
              { whitespace: true, message:'不能为空格'},
            ]
          },
          phase:{
            rules: [
              { required: true, message: '请输入期数!'},
              { pattern:/^[1-9]\/[1-9]$/, message: '期数格式为1/3,表示第1期/共3期' },
            ]
          },
          brokerageRatio: {
            rules: [
              { required: true, message: '请输入佣金比例!'},
              { type: 'number', message: '只能输入数值' },
            ]
          },
          brokerage: {
            rules: [
              { required: true, message: '请输入佣金!'},
              { type: 'number', message: '只能输入数值' },
            ]
          }
        },
        url: {
          add: "/bms/bizInsuranceData/add",
          edit: "/bms/bizInsuranceData/edit",
          queryById: "/bms/bizInsuranceData/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      //this.showFlowData();
    },
    methods: {
      moneyFormatter,
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'date','companyNumber','policy', 'phase', 'brokerageRatio','brokerage','status','project','sysOrgCode'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },

      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            formData.phase = formData.phase.trim();
            formData.policy = formData.policy.trim();
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'date','companyNumber','policy', 'phase', 'brokerageRatio','brokerage','status','project','sysOrgCode'))
      },
    }
  }
</script>